import Slider from './common/slider';

////

const Init = () => {
	
	Slider();

}

Init();
